const EXTENSION_BY_MIME_TYPE: Record<string, string> = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/gif': 'gif',
  'image/heic': 'heic',
}

export const getMimeType = (contentType: string | undefined) =>
  contentType?.split(';')[0]?.trim() || 'application/octet-stream'

export const getFileExtension = (contentType: string | undefined) =>
  EXTENSION_BY_MIME_TYPE[getMimeType(contentType)] ?? 'jpg'

export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob)
  const anchor = window.document.createElement('a')
  window.document.body.appendChild(anchor)
  anchor.href = url
  anchor.download = fileName
  anchor.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(url)
    window.document.body.removeChild(anchor)
  }, 0)
}
